export default __webpack_public_path__ + "static/escritorioRibeirao-029d9ace029569ec38bde6c7b7064353.png";